module.exports = __webpack_public_path__ + "img/Banner.e1e3ec8a.png";